function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller("AggregationCardConfiguration", ["$scope", 'ExplorerService', 'Measures', 'Dimensions', '$q', '$http', 'Api', 'AggregationUtils', 'Utils', function ($scope, ExplorerService, Measures, Dimensions, $q, $http, Api, AggUtils, Utils) {
    var cardToEdit = ExplorerService.getCard() || {};
    $scope.measureSelector = {
      disabled: false
    };
    if ($scope.tempMeasures && !_.isEmpty($scope.tempMeasures)) {
      cardToEdit.configuration.measures = $scope.tempMeasures;
    }
    if (!$scope.getMeasures) {
      $scope.getMeasures = Measures.getCommonMeasures;
    }

    //stop the bleeding here
    //we should use promises in all the controllers to handle this instead of passing on the scope
    $scope.measures = [];
    function applySelectedDimensionToWorkingConfig() {
      //initialize dimensions array just in case they are null or empty
      if (!$scope.workingConfig.dimensions || $scope.workingConfig.dimensions.length === 0) {
        $scope.workingConfig.dimensions = [{}];
      }
      var currentStatementProperty = Utils._try(function () {
        return $scope.selectedDimension.val.statementProperty;
      }, null);
      var currentOptionalStmtProp = Utils._try(function () {
        return $scope.optionalDimension.val.statementProperty;
      }, null);
      if (currentStatementProperty === currentOptionalStmtProp) {
        $scope.optionalDimension = null;
        $scope.workingConfig.dimensions = [$scope.selectedDimension.val];
      } else {
        $scope.workingConfig.dimensions[0] = $scope.selectedDimension.val;
      }
      setOptionalDimensionList();
      updatePreview();
    }
    $scope.onSelectedDimensionChanged = applySelectedDimensionToWorkingConfig;
    $scope.onStatementPropertyChanged = _.debounce(applySelectedDimensionToWorkingConfig, 100);
    function setOptionalDimensionList() {
      $scope.optionalDimensions = Dimensions.getValidOptionalDimensions($scope.selectedDimension);
      if ((!$scope.optionalDimensions || !$scope.optionalDimensions.length) && !$scope.workingConfig.line) {
        $scope.workingConfig.dimensions.splice(1, 1);
        $scope.optionalDimension = null;
      }
    }
    function applyOptionalDimensionChange() {
      if ($scope.optionalDimension) {
        if (!isJoinedCompoundDimension()) {
          $scope.workingConfig.dimensions = [$scope.selectedDimension.val, $scope.optionalDimension.val];
        }
        $scope.sortConfig.setOptions([$scope.selectedDimension, $scope.optionalDimension], $scope.measures);
        updatePreview();
      } else if (Dimensions.isCompoundDimension($scope.workingConfig)) {
        $scope.optionalDimension = getSecondDimension();
      }
    }
    $scope.onOptionalDimensionChange = applyOptionalDimensionChange;
    $scope.reverseCompoundDimension = function reverseCompoundDimension() {
      if ($scope.workingConfig.dimensions.length === 2) {
        var _$scope$workingConfig = _slicedToArray($scope.workingConfig.dimensions, 2),
          second = _$scope$workingConfig[0],
          first = _$scope$workingConfig[1];
        $scope.workingConfig.dimensions = [first, second];
        if ($scope.selectedDimension.other) {
          $scope.selectedDimension = Dimensions.getCommonDimensionFromKey($scope.selectedDimension.val.statementProperty);
        }
        var tmp = $scope.optionalDimension;
        $scope.optionalDimension = $scope.selectedDimension;
        $scope.selectedDimension = tmp;
      } else if (isJoinedCompoundDimension()) {
        var prop = $scope.workingConfig.dimensions[0].statementProperty;
        $scope.workingConfig.dimensions[0].statementProperty = prop.split('+').reverse().join('+');
        $scope.selectedDimension = Dimensions.getCommonDimensionFromKey($scope.workingConfig.dimensions[0]);
      }
      applySelectedDimensionToWorkingConfig();
    };
    var clearPreviousWatcher = createMeasureWatcher();
    $scope.$on('working-config-reassigned', rebuildWatcherFromNewReference);
    function createMeasureWatcher() {
      return $scope.$watchCollection('workingConfig.measures', function (measures, oldMeasures) {
        if (!measures || angular.equals(measures, oldMeasures)) {
          return;
        }
        $scope.measures = measures;
        updatePreview();
      });
    }
    function rebuildWatcherFromNewReference(event, newWorkingConfigReference) {
      $scope.measures = newWorkingConfigReference.measures;
      clearPreviousWatcher();
      clearPreviousWatcher = createMeasureWatcher();
    }
    function updatePreview() {
      $scope.updateSortConfig();
      $scope.updateCardWithWorkingConfig();
    }
    $scope.editing = null;
    $scope.notInMeasures = function (m) {
      return !_.find($scope.measures, function (measure) {
        return measure && angular.equals(measure.id, m.id);
      });
    };
    $scope.$watch('measureMenuOpen', function (isOpen) {
      if (!isOpen) {
        $scope.textFilter = {};
      }
    });
    $scope.saveMeasure = function saveMeasure() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          suppressReload: false,
          measure: null
        },
        suppressReload = _ref.suppressReload,
        measure = _ref.measure;
      if (measure) {
        $scope.measures.push(measure);
      }
      $scope.workingConfig.measures = $scope.measures;
      $scope.tempMeasures = $scope.measures;
      $scope.workingConfig.type = $scope.templateType;
      $scope.updateCardWithWorkingConfig(suppressReload);
      $scope.measureMenuOpen = false;
    };
    $scope.removeMeasure = function removeMeasure(i) {
      $scope.measures.splice(i, 1);
      $scope.workingConfig.measures = $scope.measures;
      $scope.tempMeasures = $scope.measures;
      $scope.workingConfig.type = $scope.templateType;
      $scope.updateCardWithWorkingConfig();
    };
    $scope.clearMeasures = function () {
      $scope.measures = [];
      $scope.workingConfig.measures = $scope.measures;
      $scope.tempMeasures = [];
      $scope.updateCardWithWorkingConfig();
    };

    // We need dimensions with names IN ORDER; so we need to use workingConfig which doesn't have names
    function getCompoundDimensionsWithNamesInOrder(workingConfig) {
      var dimensions = Dimensions.getCommonDimensions();
      var joinedColumns = Utils._try(function () {
        return workingConfig.dimensions[0].statementProperty.includes('+');
      }, false);
      var workingConfigDimensions = JSON.parse(JSON.stringify(workingConfig.dimensions)); // Copy; don't want to modify reference

      if (joinedColumns) {
        workingConfigDimensions = Dimensions.separateCompoundDimension(workingConfig.dimensions[0]).map(function (d) {
          return d.val;
        });
      }
      return workingConfigDimensions.map(function (compoundDimension) {
        return dimensions.filter(function (commonDimension) {
          return Utils._try(function () {
            return commonDimension.val.type === compoundDimension.type && commonDimension.val.statementProperty === compoundDimension.statementProperty;
          }, false);
        })[0];
      });
    }
    function isJoinedCompoundDimension() {
      return Utils._try(function () {
        return $scope.workingConfig.dimensions[0].statementProperty.includes('+');
      }, false);
    }
    function getSecondDimension() {
      if (isJoinedCompoundDimension()) {
        return Dimensions.getCommonDimensionFromKey($scope.workingConfig.dimensions[0].statementProperty.split('+')[1]);
      } else {
        return Dimensions.getCommonDimensionFromKey($scope.workingConfig.dimensions[1]);
      }
    }
    function getWorkingDimensionList() {
      if (isJoinedCompoundDimension()) {
        return $scope.workingConfig.dimensions[0].statementProperty.split('+').map(Dimensions.getCommonDimensionFromKey);
      } else {
        return $scope.workingConfig.dimensions.map(Dimensions.getCommonDimensionFromKey);
      }
    }
    $scope.getDimensionLabel = _.debounce(function getDimensionLabel() {
      if (Dimensions.isCompoundDimension($scope.workingConfig)) {
        if (isJoinedCompoundDimension()) {
          var dimensions = $scope.workingConfig.dimensions[0].statementProperty.split('+').map(Dimensions.getCommonDimensionFromKey);
          return "".concat(dimensions[0].name, " and ").concat(dimensions[1].name.toLowerCase(), ".");
        } else if ($scope.selectedDimension && $scope.optionalDimension) {
          return "".concat($scope.selectedDimension.name, " and ").concat($scope.optionalDimension.name.toLowerCase(), ".");
        } else {
          return $scope.selectedDimension.name + '.';
        }
      } else {
        return Utils._try(function () {
          return "".concat($scope.selectedDimension.name, ".");
        }, '');
      }
    }, 200);

    // Update sortConfig.options when measures/dimension changes
    // Note that it can be defined by the specific chart configuration,
    // or it will be set to the generic update function below:
    $scope.updateSortConfig = $scope.updateSortConfig || function () {
      $scope.hideMeasures = AggUtils.hideMeasures($scope.workingConfig);
      $scope.hideNonSortableFilter = AggUtils.hideNonSortableFilter($scope.workingConfig);
      var dimensions = $scope.optionalDimension && Dimensions.isCompoundDimension($scope.workingConfig) ? getCompoundDimensionsWithNamesInOrder($scope.workingConfig) : $scope.selectedDimension;
      $scope.sortConfig.setOptions(dimensions, $scope.measures);
    };

    // NOTE: This can be defined in the chart-specific configuration or it will be
    // the generic function defined below.
    $scope.sortSelected = $scope.sortSelected || function () {
      $scope.workingConfig.defaultSort = $scope.sortConfig.sortDirective();
      $scope.updateCardWithWorkingConfig();
    };
    $scope.config = cardToEdit.configuration;

    // NOTE: This can be defined in the chart-specific configuration or it will be
    // the generic object defined below:
    var dimension = Utils._try(function () {
      return $scope.config.dimensions[0];
    }, null);
    var sortConfigOptions = $scope.sortConfigOptions || {
      dimension: {
        name: AggUtils.getDimensionInSentence(dimension),
        val: dimension
      },
      measures: $scope.config.measures,
      defaultSort: $scope.config.defaultSort
    };
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions);
    var isCompoundDimension = Dimensions.isCompoundDimension($scope.workingConfig);
    $scope.sortConfig.setSelections($scope.workingConfig.defaultSort || $scope.sortConfig.defaultSort, isCompoundDimension);

    // Initialize sortConfig selections
    $scope.$watch("workingConfig.defaultSort", function (value) {
      if (!value) {
        return;
      }
      var isCompoundDimension = Dimensions.isCompoundDimension($scope.workingConfig);
      $scope.sortConfig.setSelections(value, isCompoundDimension);
    });
    $scope.onColumnLayoutChange = updatePreview;
    return $q.all([$scope.getMeasures(), $http.get(Api.url("/measure-categories"))]).then(function (response) {
      var measures = response[0];
      // We only want non-empty categories here
      var categories = _.filter(response[1].data.results, function (c) {
        if (c.measures === undefined) {
          return false;
        }

        // Filter out measures they don't have permissions to, and only include
        // categories that have permitted measures
        var permittedMeasures = _.filter(c.measures, function (catMeasure) {
          return _.findWhere(measures, {
            id: catMeasure.id
          });
        });
        c.measures = permittedMeasures;
        return c.measures !== undefined && c.measures.length > 0;
      });

      // Pull out top level menu items
      var menuItems = _.filter(measures, function (m) {
        return m.measureCategoryName === "None";
      });

      // Add all the categories as well
      menuItems = menuItems.concat(categories);
      menuItems = _.sortBy(menuItems, 'menuPosition');
      var isMeasure = function isMeasure(x) {
        return !x.measures && !!x.aggregation && !!x.valueProducer;
      };
      var isMeasureCategory = function isMeasureCategory(x) {
        return !!x.measures && !x.aggregation && !x.valueProducer;
      };
      $scope.availableMeasures = menuItems.filter(function (x) {
        return isMeasure(x) || isMeasureCategory(x);
      });
      $scope.flattenedMeasures = _.filter($scope.availableMeasures, isMeasure);
      // Now append the measures contained in categories
      var categoryMeasures = [];
      _.each(_.filter($scope.availableMeasures, isMeasureCategory), function (c) {
        categoryMeasures = categoryMeasures.concat(c.measures);
      });
      $scope.flattenedMeasures = $scope.flattenedMeasures.concat(categoryMeasures);
      $scope.measureDisplayNames = _.object(_.pluck($scope.flattenedMeasures, 'id'), _.pluck($scope.flattenedMeasures, 'name'));
      var tempMeasures = cardToEdit.configuration.measures;
      if (tempMeasures) {
        $scope.measures = tempMeasures;
      } else {
        var defaultMeasure = _.find($scope.availableMeasures, function (m) {
          return m.name === "Interaction Count";
        });

        // We should always have the Interaction Count measure, but it's possible for it to be
        // deleted or renamed.
        if (!defaultMeasure) {
          defaultMeasure = $scope.availableMeasures[0];
        }

        // If this measure is category, reach in and get the first measure
        if (defaultMeasure.measures) {
          defaultMeasure = defaultMeasure.measures[0];
        }
        $scope.measures = [angular.copy(defaultMeasure)];
        if (cardToEdit.template.name === 'correlation') {
          //add a second default measure for the correlation card
          $scope.measures.push(angular.copy($scope.availableMeasures[1]));
          $scope.xMeasure = $scope.measures[0];
          $scope.yMeasure = $scope.measures[1];
        }
      }
      $scope.dimensions = Dimensions.getCommonDimensions();
      if (Dimensions.isCompoundDimension($scope.workingConfig)) {
        var _getWorkingDimensionL = getWorkingDimensionList(),
          _getWorkingDimensionL2 = _slicedToArray(_getWorkingDimensionL, 2),
          primary = _getWorkingDimensionL2[0],
          optional = _getWorkingDimensionL2[1];
        $scope.selectedDimension = primary;
        $scope.optionalDimension = optional;
      } else {
        var tempDimension = null;
        if (!_.isUndefined(cardToEdit.configuration.dimensions) && cardToEdit.configuration.dimensions.length > 0) {
          var firstDimension = cardToEdit.configuration.dimensions[0];
          if (firstDimension.val) {
            firstDimension = firstDimension.val;
          }
          tempDimension = _.find($scope.dimensions, function (dimension) {
            return _.isMatch(firstDimension, dimension.val);
          });

          // Must be custom if we have one configured but not on the list of standard dimensions
          if (!tempDimension) {
            tempDimension = {
              name: "By custom " + firstDimension.type.toLowerCase() + " dimension (edit in Advanced Configuration)",
              val: firstDimension
            };
          } else {
            // Retain dimension that's in the config
            tempDimension.val = firstDimension;
          }
        }
        if (!tempDimension) {
          $scope.selectedDimension = $scope.dimensions[0];
          $scope.workingConfig.dimensions = [$scope.selectedDimension.val];
        } else {
          if (!tempDimension.val.statementProperty && cardToEdit.configuration.dimensions[0].statementProperty) {
            tempDimension.val.statementProperty = cardToEdit.configuration.dimensions[0].statementProperty;
          }
          $scope.selectedDimension = tempDimension;
        }
      }
      $scope.saveMeasure({
        suppressReload: true
      });
      updatePreview();
      setOptionalDimensionList();
    });
  }]);
})();
